export default __webpack_public_path__ + "static/media/2016-IMcover.4df70014.jpg";